var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    scopedSlots: _vm._u([
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "d-none d-desktop-block d-xl-block" },
              [
                _c(
                  "base-button",
                  { attrs: { blue: "" }, on: { click: _vm.goToContactForm } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("os360-empresas.more-info-btn")))
                    ]),
                    _vm._v(" "),
                    _c("base-icon", {
                      staticClass: "ml-2",
                      attrs: {
                        src:
                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                        color: "white"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-nav-item",
              {
                staticClass: "d-none d-desktop-block d-xl-block",
                attrs: { href: _vm.$helpers.get360AppUrl("inicio-sesion") }
              },
              [
                _c(
                  "base-button",
                  { attrs: { white: "", shadow: "", bold: "" } },
                  [_vm._v(_vm._s(_vm.$t("login.sign-in")))]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70bedade", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70bedade","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/OpensaludEmpresasLayout.vue
// module id = 2029
// module chunks = 116